import { ReactNode } from 'react';
import { Text } from '@comicrelief/component-library';

const heading = (children: ReactNode, tag: string, size: string, lineHeight: string) => {
  // Assuming we expect headings to always have an array of children:
  if (Array.isArray(children) && children[0]) {
    return (
      <Text
        tag={tag}
        size={size}
        height={lineHeight}
        uppercase
        family="Anton"
        weight="normal"
        color="black"
      >
        {children}
      </Text>
    );
  }
  return null;
};

const bold = (text: ReactNode) => (
  <Text weight="bold" size="inherit">
    {text}
  </Text>
);

export {
  heading, bold
};
